export default __webpack_public_path__ + "static/media/Regione-Abruzzo-Stemma-logo.4158390c.png";